import { IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';
 
const CustomDataTableInfoBtn: React.FC<Partial<IconButtonProps>
> = ({ ...rest }) => {
  return (
    <Tooltip hasArrow label='More Info on record' placement='auto' aria-label='More Info button tooltip'>
      <IconButton
        //   variant="outline"
        fontSize="20px"
        icon={<FiInfo />}
        aria-label="DataTable row Info"
        {...rest}
      />
    </Tooltip>
  );
};

export default CustomDataTableInfoBtn;